import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["id", "name", "value", "rows", "placeholder", "disabled"]
const _hoisted_6 = { class: "help-message absolute p-1 text-sm" }

import {
  PhPencilSlash,
} from '@phosphor-icons/vue';
import {
  useField,
} from 'vee-validate';
import type {
  PropType,
} from 'vue';
import {
  toRef,
  watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextAreaHelper',
  props: {
  name: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  rows: {
    type: Number,
    default: 4,
  },
  value: {
    type: String,
    default: '',
  },
  successMessage: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  errorText: {
    type: String,
    default: '',
  },
  resizable: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  themeNo: {
    type: Number as PropType<1 | 2>,
    default: 2,
    validator: (type: number) => type === 1 || type === 2,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["input", "blur", "change"],
  setup(__props, { emit: emits }) {

const props = __props;






const name = toRef(props, 'name');

// we don't provide any rules here because we are using form-level validation
// https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
const {
  value: inputValue,
  resetField,
  setState,
  errorMessage,
  handleBlur,
  handleChange,
  meta,
} = useField(name, undefined, {
  initialValue: props.value,
});

watch(() => props.value, () => {
  resetField({
    value: props.value,
  });
});

function onInput(e): void {
  emits('input', inputValue.value);
  handleChange(e);
}

function onBlur(e): void {
  setState({
    value: e.target.value.trim(),
  });
  emits('blur', inputValue.value);
  handleBlur(e);
}

function onChange(): void {
  emits('change', inputValue.value);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative pb-8", {
      [__props.themeNo === 1 ? 'has-error-1' : 'has-error-2']: !!_unref(errorMessage) || __props.errorText,
      [__props.themeNo === 1 ? 'success-1' : 'success-2']: _unref(meta).valid && !__props.errorText,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: name.value,
        class: "label block pt-0"
      }, [
        _createTextVNode(_toDisplayString(__props.label) + " ", 1),
        (__props.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
          : _createCommentVNode("", true)
      ], 8, _hoisted_2),
      (__props.disabled)
        ? (_openBlock(), _createBlock(_unref(PhPencilSlash), {
            key: 0,
            class: "mr-2"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("textarea", {
        id: name.value,
        name: name.value,
        value: _unref(inputValue),
        rows: __props.rows,
        placeholder: __props.placeholder,
        class: _normalizeClass([
          __props.themeNo === 1 ? 'input-1' : 'input-2',
          { 'resize-none': !__props.resizable },
        ]),
        disabled: __props.disabled,
        onInput: onInput,
        onBlur: onBlur,
        onChange: onChange
      }, null, 42, _hoisted_5)
    ]),
    _createElementVNode("p", _hoisted_6, [
      (_unref(errorMessage) || __props.errorText)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_unref(errorMessage) || __props.errorText), 1)
          ], 64))
        : (_unref(meta).valid)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(__props.successMessage), 1)
            ], 64))
          : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})